/**
 * @typedef {(paths: string[]) => string[]} WithPathsFunc
 *
 * Get a function to connect your root path with any children.
 * @param {string} rootPath The root path of this component.
 * @returns {[rootPath: string, withPaths: WithPathsFunc]}
 */
export const withReferencePath = (rootPath) => [rootPath.toString(), (paths) => paths.map((p) => `${rootPath}.${p}`)];
